module.exports = __webpack_public_path__ + "media/images/app/products/index/types/bracelets-770d28881bf908c622896ddbdcaa9c4a.webp";